<template>
    <div>
        <div class="satisfaction-title">{{$t('satisfaction.title')}}</div>
        <div class="satisfaction-top">
            <satisfaction-search></satisfaction-search>
        </div>
        <table-satisfaction></table-satisfaction>
    </div>
</template>

<script>
    import SatisfactionSearch from '../satisfaction/SatisfactionSearch'
    import TableSatisfaction from '../satisfaction/TableSatisfaction'

    export default {
        name: 'Satisfaction',
        components: {
            SatisfactionSearch,
            TableSatisfaction
        }
    }
</script>

<style scoped>
    .satisfaction-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .satisfaction-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/cases/satisfaction/Satisfaction.vue